import React, { PureComponent, PropTypes } from 'react';
import _ from 'underscore';
import Separated from '../common/components/Separated';
import { Popover } from 'react-fast-ui';
import cx from 'classnames';
import { shortRecruitName } from './ShortRecruitName';
import ShortRecruitDetailsWithPhotoAndMore from './ShortRecruitDetailsWithPhotoAndMore';
import { commonPropTypes } from '../util/constants';

function formatRecruit(recruit) {
  return shortRecruitName(recruit, true);
}

class MoreRecruits extends PureComponent {
  render() {
    const { recruits, showRecruitCount } = this.props;
    let jsx;

    if (showRecruitCount) {
      jsx = <span key="more" className="mg-left-sm">{`+ ${recruits.length} more`}</span>;
    } else {
      jsx = (
        <span key="more" className="display-inline-block">
          <span style={{ marginLeft: '10px' }}>...</span>
        </span>
      );
    }

    return jsx;
  }
}

class RecruitListItem extends PureComponent {
  static propTypes = {
    formatFunction: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    recruit: PropTypes.object.isRequired,
    fontSize: commonPropTypes.SIZES,
    popover: PropTypes.bool.isRequired
  };

  static defaultProps = {
    onClick: null
  };

  render() {
    const { open, fontSize, formatFunction, onClick, recruit, popover, ...rest } = this.props;

    const recruitInfo = <span className={`${fontSize}-font`} {...rest}>{formatFunction(recruit)}</span>;

    const linkedRecruitInfo = onClick ? <a onClick={onClick}>{recruitInfo}</a> : recruitInfo;

    if (!popover) {
      return linkedRecruitInfo;
    }

    return (
      <Popover open={open} buffer={30} content={<ShortRecruitDetailsWithPhotoAndMore recruit={recruit}/>}>
        { linkedRecruitInfo }
      </Popover>
    );
  }
}

export default class RecruitList extends PureComponent {
  static propTypes = {
    recruits: PropTypes.array.isRequired,
    recruitClassName: PropTypes.string,
    fontSize: commonPropTypes.SIZES,
    maxVisibleRecruits: PropTypes.number,
    onClickRecruit: PropTypes.func,
    formatFunction: PropTypes.func,
    lineHeight: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
    popover: PropTypes.bool,
    separator: PropTypes.node,
    showRecruitCount: PropTypes.bool
  };

  static defaultProps = {
    recruitClassName: null,
    fontSize: 'md',
    maxVisibleRecruits: null,
    formatFunction: formatRecruit,
    lineHeight: 1.2,
    popover: true,
    showRecruitCount: false
  };

  state = {
    showRecruitDetails: false
  };

  getRemainingRecruits() {
    const { maxVisibleRecruits, recruits } = this.props;

    if (maxVisibleRecruits && recruits.length > maxVisibleRecruits) {
      return recruits.slice(maxVisibleRecruits);
    } else {
      return [];
    }
  }

  getVisibleRecruits() {
    const { maxVisibleRecruits, recruits } = this.props;
    let visibleRecruits;

    if (maxVisibleRecruits) {
      visibleRecruits = _.first(recruits, maxVisibleRecruits);
    } else {
      visibleRecruits = recruits;
    }

    return _.sortBy(visibleRecruits, 'lastName');
  }

  getClickHandler(recruit) {
    const { onClickRecruit } = this.props;

    if (onClickRecruit) {
      return () => {
        this.setState({ showRecruitDetails: null });
        onClickRecruit(recruit);
      };
    } else {
      return null;
    }
  }

  hasMoreRecruits() {
    return this.getRemainingRecruits().length > 0;
  }

  handleRecruitHover = _.debounce((recruitId) => {
    this.setState({ showRecruitDetails: recruitId });
  }, 150);

  render() {
    const {
      className,
      fontSize,
      style,
      lineHeight,
      recruitClassName,
      formatFunction,
      popover,
      showRecruitCount,
      separator
    } = this.props;
    const { showRecruitDetails } = this.state;

    return (
      <span className={cx('mg-bottom-none', className)}
        style={{ ...style, lineHeight }}>
        <Separated separator={separator}>
          {
            this.getVisibleRecruits()
              .map((recruit) => {
                return (
                  <RecruitListItem
                    fontSize={fontSize}
                    popover={popover}
                    key={recruit.id}
                    open={showRecruitDetails === recruit.id}
                    recruit={recruit}
                    className={recruitClassName}
                    formatFunction={formatFunction}
                    onClick={this.getClickHandler(recruit)}
                    onMouseEnter={() => this.handleRecruitHover(recruit.id)}
                    onMouseLeave={() => this.handleRecruitHover(null)}
                  />
                );
              })
          }
        </Separated>
        {this.hasMoreRecruits() ?
          <MoreRecruits recruits={this.getRemainingRecruits()} showRecruitCount={showRecruitCount}/>
          :
          null
        }

      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/RecruitList.jsx